import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const programFields = [
  "gaming_programid", // UID
  "gaming_HubSubmittedByID", // UID
  "gaming_name", // Text
  "gaming_Game", // Lookup - Gaming_GameConcept
  "gaming_Initiative", // Lookup - Gaming_Initiatives
  "gaming_ProgramStatus", // Choice
  "gaming_hubprogramdisplaystatus",
  "gaming_hubprogramtargetdateutc", // Date
  "gaming_programtargetdateutc", // Date
  "gaming_hubsubmitteddate", // Date
  "gaming_hubopened",
] as const;

export const programReferences: EntityReferences<EntityName.gaming_program> = {
  [EntityName.gaming_initiatives]: ["gaming_Initiative"],
  [EntityName.gaming_gameconcept]: ["gaming_Game"],
  [EntityName.contact]: ["gaming_HubSubmittedByID"],
};

export const programKey: AnyEntityField<EntityName.gaming_program> = "gaming_programid";
